import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrivateThreadThunk } from './getPrivateThread';
import { setIsRecording } from '../slices/videoChatSlice';

export const handleWebsocketMessageThunk = createAsyncThunk(
  'chat/handleWebsocketMessage',
  async ({ event, user }, { getState, dispatch }) => {
    const newMessage = JSON.parse(event.data);
    const messageType = newMessage?.type?.split('#')[0];

    let threadWasFetched = false;

    // If this is a MESSAGE from a direct recipient and we don't have the thread in state, fetch it
    if (
      messageType === 'MESSAGE' &&
      newMessage.directRecipient &&
      newMessage.userId !== user?.id
    ) {
      const state = getState();
      const existingThread = state.chatSlice.threads[newMessage.threadId];

      if (!existingThread) {
        // Fetch the private thread so it's added to state
        // The thread from backend already includes the unread count for this message
        // setAsActive: false prevents this from becoming the active thread
        await dispatch(
          getPrivateThreadThunk({
            userId: newMessage.userId,
            setAsActive: false,
            projectId: newMessage.projectId,
          })
        );
        threadWasFetched = true;
      }
    }

    // Handle recording start/stop notifications
    if (messageType === 'VIDEOCHAT_RECORDING') {
      dispatch(setIsRecording(newMessage.isActive === true));
    }

    return { message: newMessage, threadWasFetched };
  }
);
